import React, { useEffect, useState } from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import formatContentfulRichText from "@qlik/qlik/src/lib/format-rich-text-content";
import { Tooltip as ReactTooltip } from "react-tooltip";

import * as styles from "./Tooltip.module.css";

const Tooltip = ({ data }) => {
    const [isMounted, setMounted] = useState(false);
    const { id, body } = data ?? {};

    useEffect(() => {
        setMounted(true);
    }, []);

    return (
        isMounted &&
        body && (
            <span className={`${styles.tooltipWrapper} tooltipWrapper`}>
                <span className="flex items-center justify-between gap-x-1.25">
                    <span
                        data-tooltip-id={id}
                        className=" block flex-shrink-0 w-6 h-6 bg-infoIcon hover:cursor-pointer bg-no-repeat"
                    />
                </span>
                <ReactTooltip
                    id={id}
                    place="right"
                    opacity={1}
                    clickable
                    offset={20}
                    className="tooltip max-w-[280px] lg:max-w-80"
                    classNameArrow="max-w-0 max-h-0 after:absolute after:top-1/2 after:w-6.5 after:h-6 after:bg-tooltipArrowIcon after:bg-no-repeat"
                >
                    {renderRichText(body, formatContentfulRichText())}
                </ReactTooltip>
            </span>
        )
    );
};

export default Tooltip;
